$(document).ready(function(){
	var headerHeight = $('header.lg\\:fixed').outerHeight();
	var viewportWidth = $(window).width();
	if ( viewportWidth >= 1080 ) {
		$('.fixed-header').css({'margin-top':headerHeight});
		$('.fixed-padding').css({'padding-top':headerHeight});
		$( '.dropdown' ).mouseenter(function() {
			$( this ).find('.dropdown-menu').first().removeClass('hidden');
		}).mouseleave(function() {
			$( this ).find('.dropdown-menu').first().addClass('hidden');
		});
		var stickyHeader = $('header.lg\\:fixed');
		$(window).scroll(function() {
			var headerVideo = $('#header-trigger-video');
			var headerMap = $('#header-trigger-map');
			if ( headerVideo.length ) {
				var videoTrigger = $('#header-trigger-video').offset();
				if ( $(window).scrollTop() >= videoTrigger.top - headerHeight ) {
					$('header.lg\\:fixed').removeClass('dark-bg').addClass('light-bg bg-white');
					$('header .brand').removeClass('text-white hover:text-blue-200').addClass('text-blue-500 hover:text-blue-400');
				} else {
					$('header.lg\\:fixed').removeClass('light-bg bg-white').addClass("dark-bg");
					$('header .brand').removeClass('text-blue-500 hover:text-blue-400').addClass('text-white hover:text-blue-200');
				}
			}
			if ( headerMap.length ) {
				var mapTrigger = $('#header-trigger-map').offset();
				if ( $(window).scrollTop() >= mapTrigger.top - headerHeight ) {
					$('header.lg\\:fixed').removeClass('dark-bg bg-blue-500 lg:bg-opacity-80').addClass('light-bg bg-white');
					$('header .brand').removeClass('text-white hover:text-blue-200').addClass('text-blue-500 hover:text-blue-400');
				} else {
					$('header.lg\\:fixed').removeClass('light-bg bg-white').addClass("dark-bg bg-blue-500 lg:bg-opacity-80");
					$('header .brand').removeClass('text-blue-500 hover:text-blue-400').addClass('text-white hover:text-blue-200');
				}
			}
		});
	} else {
		$('#mobile-nav').click(function(){
			$('.mobile-menu, #mobile-nav span').toggleClass('hidden');
			$('.dropdown-menu').addClass('hidden');
		});
		$('.nav-primary .menu-item-has-children > a').click(function(e){
			e.preventDefault();
			$(this).siblings('.dropdown-menu').toggleClass('hidden');
		});
	}

	(function($) {
		$.fn.unwrapUntil = function() {
			var arg = arguments[0],
				type = typeof arguments[0];
			if(type === "number") {
				//Argument is a number, remove that number of ancestor elements
				$.each(this, function() {
					var $this = $(this);
					for(var i = 0; i < arg; i++) {
						$this.unwrap();
					}
				});
			}
			else if(type === "string") {
				//Argument is a selector string, remove ancestor elements until the parent matches the selector
				$.each(this, function() {
					var $this = $(this);
					if($this.closest(arg).length > 0) {
						while($this.parent(arg).length === 0) {
							$this.unwrap();
						}
					}
				});
			}
			else if(type === "object") {
				//Argument is an object, remove ancestor elements until the parent is equal to that object
				$.each(this, function() {
					var $this = $(this);
					if($this.closest(arg).length > 0) {
						while($this.parent()[0] !== arg[0]) {
							$this.unwrap();
						}
					}
				});
			}
			return this;
		};
	})(jQuery);

	$('.wp_unwrapper').unwrapUntil('.wp-block-group');
});

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

var getLangCode = document.documentElement.lang;
var tac_close;

if (getLangCode == 'fr-FR') {
  tac_close = 'Continuez sans accepter';
} else {
  tac_close = 'Continue without accepting';
}

window.addEventListener('tac.root_available', function () {
  setTimeout(function () {
    $('#tarteaucitronCloseCross').html(tac_close);
  }, 200);
});

$(document).on('click', '#tarteaucitronCloseCross', function (e) {
  e.preventDefault();
  /*global tarteaucitron*/
  tarteaucitron.userInterface.respondAll(false);
});
